import type { EnableSocialAdsRequest } from '@nucleus-commerce/api-client/admin';

import type { AdAccountPickForm } from '../schemas/ad-account-schema';

export function toEnableAdsBody(values: AdAccountPickForm): EnableSocialAdsRequest {
  return { adAccountId: values.adAccountId };
}
